import '../styles/theme.css';

const Loading = () => {
    return (
        <div className="d-flex justify-content-center">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden" />
            </div>
        </div>
    );
}

export default Loading;